import { render, staticRenderFns } from "./todayDiscount.vue?vue&type=template&id=4bc75ad4&scoped=true&"
import script from "./todayDiscount.vue?vue&type=script&lang=js&"
export * from "./todayDiscount.vue?vue&type=script&lang=js&"
import style0 from "./todayDiscount.vue?vue&type=style&index=0&id=4bc75ad4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc75ad4",
  null
  
)

export default component.exports